import http from './http';

export function redeemCode(redeemCode) {
  return http.post('/redeem-codes/redeem', { redeemCode });
}

export function fetchRedeemHistory() {
  return http.get('/redeem-codes/history');
}
